// All reducers from ninjas-dialog and reducers.
import { combineReducers } from 'redux';
import {
  ninjasAllSelected,
  ninjasSelected,
  pageNumber,
  rowsPerPage,
  searchStringTyped,
} from './reducers/update-ninjas-reducer';
import {
  isOpen,
  form,
} from './add-ninja-dialog/reducers';

const ninjaDialog = combineReducers({
  isOpen,
  form,
});

export default combineReducers({
  ninjasAllSelected,
  ninjasSelected,
  pageNumber,
  rowsPerPage,
  searchStringTyped,
  ninjaDialog,
});



/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/reducers.js
 **/